
export default {
    props: {
        userIdCardInfo: {
            type: Object
        }
    },
    data() {
        return {
            imageUrl: 'https://oss.pzds.com/imgv2/qr-zhifubao.png',
            qrCodeLoading: false,
            qrError: false,
            realTime: null,
            certifyId: null,
            certifyUrl: null
        }
    },
    mounted() {
        const p = {
            action: this.userIdCardInfo
        }
        this.qrCodeLoading = true
        this.$api
            .userCertify(p)
            .then((res) => {
                if (!res.success) {
                    let self = this
                    this.$message.error(res.info)

                    let timer = setTimeout(() => {
                        self.$emit('close')
                        clearTimeout(timer)
                    }, 1000)
                    return
                }
                this.qrCodeLoading = false
                this.certifyId = res.data.certifyId //认证查询标识
                this.certifyUrl = res.data.certUrl //支付宝二维码地址
                // 轮询
                this.startRepeat()
            })
            .catch(() => {
                this.qrCodeLoading = false
            })
    },
    methods: {
        // 创建二维码
        crateQrcode(qrCodeUrl) {
            this.qr = new QRCode('qrcode', {
                width: 240,
                height: 240, // 高度
                text: qrCodeUrl, // 二维码内容
                correctLevel: QRCode.CorrectLevel.L
            })
        },
        // 开始轮询
        startRepeat() {
            let self = this
            this.realTime = setInterval(() => {
                this.checkUserIdCardInfo(this.certifyId)
            }, 3000)

            // 10分钟没动就不调用接口,关闭弹窗
            setTimeout(() => {
                this.qrCodeLoading = true
                clearInterval(self.realTime)
                self.$emit('closeRealName')
            }, 50000)
        },
        // 检查用户身份证信息----轮询
        checkUserIdCardInfo() {
            let p = {
                action: {
                    certifyId: this.certifyId
                }
            }
            this.$api.queryUserCertify(p).then((res) => {
                if (res.success) {
                    let data = res.data
                    if (data.passed === true) {
                        // 认证成功
                        this.clearIntervalRealTime()
                        this.$emit('closeRealName', this.certifyId)
                    }
                    if (data.passed === false) {
                        // 认证失败
                        this.clearIntervalRealTime()
                        this.$emit('closeRealName', null)
                    }
                } else {
                    // 否则继续轮询
                    this.clearIntervalRealTime()
                    this.$message.error(res.info)
                }
            })
        },
        clearIntervalRealTime() {
            let self = this
            clearInterval(self.realTime)
        }
    },
    destroyed() {
        let self = this
        clearInterval(self.realTime)
    }
}
